var _circle, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 9,
    r: 2,
    fill: "#D80032"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.532 5.08v6.456H18V13h-5.088V5.08h1.62zm4.873 0h1.62V13h-1.62V5.08zm6.694 4.8l1.968-4.8h1.824l-3.528 8.064h-.54l-3.54-8.064h1.836l1.98 4.8zM31.172 13V5.08H36.5v1.464h-3.708v1.608h2.724v1.38h-2.724v2.004h3.852V13h-5.472z",
    fill: "#D80032"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 17,
    rx: 2.5,
    stroke: "#D80032"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCA0MiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNiIgY3k9IjkiIHI9IjIiIGZpbGw9IiNEODAwMzIiLz4KPHBhdGggZD0iTTE0LjUzMiA1LjA4VjExLjUzNkgxOFYxM0gxMi45MTJWNS4wOEgxNC41MzJaTTE5LjQwNSA1LjA4SDIxLjAyNVYxM0gxOS40MDVWNS4wOFpNMjYuMDk4NiA5Ljg4TDI4LjA2NjYgNS4wOEgyOS44OTA2TDI2LjM2MjYgMTMuMTQ0SDI1LjgyMjZMMjIuMjgyNiA1LjA4SDI0LjExODZMMjYuMDk4NiA5Ljg4Wk0zMS4xNzIyIDEzVjUuMDhIMzYuNTAwMlY2LjU0NEgzMi43OTIyVjguMTUySDM1LjUxNjJWOS41MzJIMzIuNzkyMlYxMS41MzZIMzYuNjQ0MlYxM0gzMS4xNzIyWiIgZmlsbD0iI0Q4MDAzMiIvPgo8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjQxIiBoZWlnaHQ9IjE3IiByeD0iMi41IiBzdHJva2U9IiNEODAwMzIiLz4KPC9zdmc+Cg==";
export { SvgLive as ReactComponent };